export default __webpack_public_path__ + "static/media/Subtact - Want You (feat. Sara Skinner) [NCS Release].cba03d8a.mp3";